// extracted by mini-css-extract-plugin
export default {"price":"CouponPriceDetails_price__cYcdW","price-related-value":"CouponPriceDetails_price-related-value__eGF+R"};